import Quill from 'quill/core';
import React from 'react';
import { MenuItem } from '../../components/Menu';
import linkIcon from '../../icons/non-prefilled/16x16/link.svg';
import replaceBlotWith from '../utils/replaceBlotWith';
import type { EmbedBlot } from '../types';

const Parchment = Quill.import('parchment');

interface DisplayAsLinkMenuItemProps {
  quill: Quill;
  blot: EmbedBlot;
  link: string;
  onClick?: () => void;
}

const DisplayAsLinkMenuItem = ({
  quill,
  blot,
  link,
  onClick,
}: DisplayAsLinkMenuItemProps) => (
  <MenuItem
    icon={linkIcon}
    onClick={() => {
      replaceBlotWith(
        quill,
        blot,
        // eslint-disable-next-line no-bitwise
        blot.statics.scope & Parchment.Scope.LEVEL & Parchment.Scope.BLOCK
          ? `${link}\n`
          : link,
        { link },
      );
      onClick?.();
    }}
    testId="displayAsLinkMenuItem"
  >
    Display as link
  </MenuItem>
);

export default DisplayAsLinkMenuItem;
